import { Button, Box, RadioGroup, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
export const DescriptionText = styled(Typography)({
    fontSize: '12px',
    marginBottom: '16px',
    fontWeight: 400
});
export const SectionHeading = styled(Typography)({
    marginBottom: '4px',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '24px',
    color: 'var(--color-brand)'
});
export const HeadingAccentBar = styled(Box)({
    height: '3px',
    width: '52px',
    backgroundColor: 'var(--color-brand)'
});
export const SectionDivider = styled(Box)({
    height: '1px',
    width: '100%',
    backgroundColor: '#e0e0e0',
    marginBottom: '16px'
});
export const StyledRadioGroup = styled(RadioGroup)({
    gap: '16px',
    '& .MuiButtonBase-root': {
        margin: '0 8px 0 0'
    }
});
export const ReasonTitle = styled(Typography)({
    fontWeight: 400,
    fontSize: '12px'
});
export const ReasonDescription = styled(Typography)({
    marginTop: '8px',
    marginLeft: '4px',
    fontSize: '10px',
    display: 'block',
    fontWeight: 400
});
export const AlertConfigBox = styled(Box)({
    marginTop: '16px',
    padding: '16px',
    border: '1px solid #E6E6E7',
    borderRadius: '16px'
});
export const ActionButtonsRow = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginTop: '16px',
    width: '100%',
    '& .MuiButton-root': {
        minHeight: '22px',
        height: '22px',
        padding: '4px 12px',
        fontSize: '10px',
        fontWeight: 600,
        borderRadius: '3px',
        textAlign: 'center'
    }
});
export const PrimaryActionButton = styled(Button)({
    textTransform: 'none',
    borderRadius: '10px',
    minWidth: 'auto',
    height: '32px',
    paddingLeft: '16px',
    paddingRight: '16px',
    borderColor: 'var(--color-brand) !important',
    color: 'var(--color-brand) !important'
});
export const SecondaryActionButton = styled(Button)({
    textTransform: 'none',
    borderRadius: '10px',
    minWidth: 'auto',
    height: '32px',
    paddingLeft: '16px',
    paddingRight: '16px',
    color: 'var(--color-brand) !important'
});
